import { render, staticRenderFns } from "./idle.vue?vue&type=template&id=71eedb05&scoped=true"
import script from "./idle.vue?vue&type=script&lang=js"
export * from "./idle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eedb05",
  null
  
)

export default component.exports